import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@home/src/app/core/services/Auth/authservice';
import { CommentsService } from '@home/src/app/core/services/comments/comments.service';
import { CustomReportService } from '@home/src/app/core/services/CustomReport/custom-report.service';
import { GlobalService } from '@home/src/app/core/services/global/global.service';
import { INotification } from '@home/src/app/Interface/notification';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-single-notification',
  standalone: true,
  imports: [],
  templateUrl: './single-notification.component.html',
  styleUrl: './single-notification.component.css',
})
export class SingleNotificationComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  @Input({ required: true }) notification!: INotification;

  authUser: any = null;

  constructor(
    private commentsService: CommentsService,
    private authService: AuthenticationService,
    private globalService: GlobalService,
    private customReportService: CustomReportService,
  ) {}

  ngOnInit() {
    this.authService.fincomData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.authUser = state;
      });
  }

  async clearNotification(isServer: boolean) {
    if (isServer) {
      const response = await this.commentsService.removeServerNotification(
        this.notification,
        this.authUser?.email,
      );
      if (response?.statusCode === 200)
        this.globalService.showToast(
          'Notification removed successfully',
          'success',
        );
      else
        this.globalService.showToast('Failed to remove notification', 'error');
    } else {
      this.commentsService.removeLocalNotification(this.notification);
    }
  }

  async getReportLink(queueId: string) {
    try {
      await this.customReportService.getReportLink(queueId);
    } catch (error) {
      console.error('Failed to download report:', error);
      this.globalService.showToast(
        'Download failed. Please try again.',
        'error',
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
